<template>
    <el-container class="layout">
        <el-header>
            <Header />
        </el-header>
        <el-container>
            <el-main>
                <el-card shadow="hover">
                    <el-button
                        type="primary"
                        style="width: 120px"
                        @click="handleAdd"
                        >新增</el-button
                    >
                    <input type="file" id="excel-file">
                </el-card>
                <br />
                <el-card shadow="hover">
                    <el-table
                        v-loading="table.loading"
                        :data="table.data"
                        stripe
                        style="width: 100%"         
                    >
                        <el-table-column type="index"></el-table-column>
                        <el-table-column prop="name" label="基地名称" width="400">
                        </el-table-column>
                        <el-table-column prop="build_time" label="建立时间">
                        </el-table-column>
                          <el-table-column prop="college" label="所属学院">
                        </el-table-column>
                        <el-table-column prop="major" label="面向学校专业" width="100">
                        </el-table-column>
                        <el-table-column prop="major_code" label="校内专业代码">
                        </el-table-column>
                        <el-table-column
                            prop="is_internship"
                            label="是否是创业实习基地"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="is_practice"
                            label="是否是示范性教育实践基地"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="stu_total_number"
                            label="当年接纳学生总数（人次）"
                        >
                        </el-table-column>
                        <el-table-column prop="unit_name" label="合作单位名称">
                        </el-table-column>
                        <el-table-column prop="address" label="地址">
                        </el-table-column>
                        <el-table-column
                            prop="course_name"
                            label="承担实习课程名称"
                        >
                        </el-table-column>
                        <el-table-column prop="stu_number" label="学生人数">
                        </el-table-column>
                        <el-table-column prop="leader" label="负责人">
                        </el-table-column>
                        <el-table-column label="操作" width="160">
                            <template slot-scope="scope">
                                <el-button
                                    size="mini"
                                    @click="
                                        handleUpdate(scope.$index, scope.row)
                                    "
                                    >编辑</el-button
                                >
                                <el-button
                                    size="mini"
                                    type="danger"
                                    @click="
                                        handleDelete(scope.$index, scope.row)
                                    "
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-main>
        </el-container>
        <el-dialog width="80%" :visible.sync="dialog.show">
            <el-form v-model="dialog.data" label-width="180px">
                <el-form-item label="基地名称">
                    <el-input v-model="dialog.data.name"></el-input>
                </el-form-item>
                <el-form-item label="建立时间">
                    <el-date-picker
                        v-model="dialog.buildTime"
                        type="year"
                        placeholder="建立时间"
                        @change="handleDialogDateChanged"
                    >
                    </el-date-picker>
                </el-form-item>
                 <el-form-item label="所属学院">
                    <el-input v-model="dialog.data.college"></el-input>
                </el-form-item>
                <el-form-item label="面向学校专业">
                    <el-input v-model="dialog.data.major"></el-input>
                </el-form-item>
                <el-form-item label="校内专业代码">
                    <el-input v-model="dialog.data.major_code"></el-input>
                </el-form-item>
                <el-form-item label="是否是创业实习基地">
                    <el-radio-group v-model="dialog.data.is_internship">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否是示范性教育实践基地">
                    <el-radio-group v-model="dialog.data.is_practice">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="当年接纳学生总数（人次）">
                    <el-input v-model="dialog.data.stu_total_number"></el-input>
                </el-form-item>
                <el-form-item label="合作单位名称">
                    <el-input v-model="dialog.data.unit_name"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="dialog.data.address"></el-input>
                </el-form-item>
                <el-form-item label="承担实习课程名称">
                    <el-input v-model="dialog.data.course_name"></el-input>
                </el-form-item>
                <el-form-item label="学生人数">
                    <el-input v-model="dialog.data.stu_number"></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                    <el-input v-model="dialog.data.leader"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="submit"
                        :style="{ width: '150px', float: 'right' }"
                        >提交</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-container>
</template>

<script>
import Header from "@/components/Header.vue";
import moment from "moment";

import { getBaseList, deleteBase, changeBase} from "@/api/views/base.js";

export default {
    components: {
        Header
    },
    data() {
        return {
            table: {
                loading: true,
                data: []
            },
            dialog: {
                show: false,
                id: null,
                buildTime: null,
                data: {}
            }
        };
    },
    created() {
        this.getData();
       
    },
    /**
     * @name: 生命周期挂载
     * @desc: 获取选择文件
     * @author: lxy
     * @date: 20210918
     */
   
    methods: {
        getData() {
            this.table.loading = true;
            getBaseList().then(res => {
                this.table.data = res.data;
                this.table.loading = false;
            });
        },
        // 弹出层时间修改
        handleDialogDateChanged(date) {
            this.dialog.data.build_time = moment(date).format("YYYY");
        },
        submit() {
            changeBase(
                Object.assign(
                    {
                        id: this.dialog.id
                    },
                    this.dialog.data
                )
            ).then(() => {
                if (this.dialog.id) {
                    this.$message.success("修改成功");
                } else {
                    this.getData();
                    this.$message.success("添加成功");
                }
                this.dialog.show = false;
                this.dialog.data;
                this.dialog.buildTime="";
                this.dialog.id="";
            });
        },
        handleAdd() {
            this.dialog.show = true;
        },
        handleUpdate(index, row) {
            this.dialog.show = true;
            this.dialog.id = row.id;
            this.dialog.buildTime = row.build_time;
            this.dialog.data = row;
        },
        handleDelete(index, row) {
            deleteBase({
                id: row.id
            }).then(() => {
                this.$message.success("删除成功");
                this.getData();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.layout {
    height: 100%;
    background-color: #ecf0f5;

    .el-header {
        background-color: #fff;
    }

    .el-container {
        height: calc(100% - 64px);
    }

    .el-main {
        background-color: #ecf0f5;
    }
    #excel-file{
        position: absolute;
        display: block;
        width: 123px;
        height: 74px;
        top: 67px;
        left: 171px;
        cursor: pointer !important;
        opacity: 0;
}
}
</style>
